import { Delegate } from '../delegate'

class Topic {
  constructor(options = {}) {
    options = options || {}
    this.id = options.id
    this.duration = options.duration || 0
    this.endTime = options.endTime
    this.name = options.name
    this.sequence = options.sequence || 1
    this.speaker = Delegate.initOnlyValidFromArray(options.speaker)
    this.startTime = options.startTime
    this.type = options.type
  }

  // Class methods
  static init(options) {
    if (options instanceof Topic) {
      return options
    }
    const instance = new Topic(options)
    return instance.isValid ? instance : null
  }
  static initFromArray(arr) {
    if (Array.isArray(arr)) {
      return arr.map(this.init)
    }
    return []
  }
  static initOnlyValidFromArray(arr = []) {
    return this.initFromArray(arr).filter((i) => i)
  }

  // getters
  get isValid() {
    return !!this.name
  }

  get displayTime() {
    return `${this.startTime}-${this.endTime}`
  }

  get durationQandA() {
    const hour = Number(this.endTime.split(':')[0]) - Number(this.startTime.split(':')[0])
    const mins = Number(this.endTime.split(':')[1]) - Number(this.startTime.split(':')[1])
    return (hour * 60 + mins) - this.duration
  }

  get hasSpeaker() {
    return this.speaker.length > 0
  }

}

export default {
  Topic
}
export {
  Topic
}
